module.exports = __webpack_public_path__ + "img/web.ba857307.png";